/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto(value) {
    if (!('CountryCodeIso3166Alpha3' in value) || value['CountryCodeIso3166Alpha3'] === undefined)
        return false;
    if (!('CountryCurrencyCodeIso4217' in value) || value['CountryCurrencyCodeIso4217'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoFromJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'CountryCodeIso3166Alpha3': json['country_code_iso_3166_alpha_3'],
        'CountryCurrencyCodeIso4217': json['country_currency_code_iso_4217'],
        'Lat': json['lat'] == null ? undefined : json['lat'],
        'Lon': json['lon'] == null ? undefined : json['lon'],
    };
}
export function FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoToJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoToJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'country_code_iso_3166_alpha_3': value['CountryCodeIso3166Alpha3'],
        'country_currency_code_iso_4217': value['CountryCurrencyCodeIso4217'],
        'lat': value['Lat'],
        'lon': value['Lon'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto.js.map